'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _CallbackPage = require('./CallbackPage');

var _CallbackPage2 = _interopRequireDefault(_CallbackPage);

var _OidcCallbackSuccessRedirectAction = require('./actions/OidcCallbackSuccessRedirectAction');

var _OidcCallbackSuccessRedirectAction2 = _interopRequireDefault(_OidcCallbackSuccessRedirectAction);

var _OidcErrorAction = require('./actions/OidcErrorAction');

var _OidcErrorAction2 = _interopRequireDefault(_OidcErrorAction);

var _CwLog = require('../../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSuccess: function onSuccess(user) {
      // make sure to fire prop first that updates url to redirectUrl
      window.history.replaceState({}, '', user.state.redirectUrl);

      // udpate store to load modulemanager now that url is properly updated and restored
      // need this to tickle the store so oidcmanager can rerender properly
      dispatch((0, _OidcCallbackSuccessRedirectAction2.default)(user.state.redirectUrl));
    },
    onError: function onError(error) {
      _CwLog2.default.error('Error handling the token callback: ' + error.message);
      dispatch((0, _OidcErrorAction2.default)(error.message));
    }
  };
};

var CallbackPageContainer = (0, _reactRedux.connect)(null, mapDispatchToProps)(_CallbackPage2.default);

exports.default = CallbackPageContainer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/oidc/CallbackPageContainer.js
// module id = 339
// module chunks = 10